var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import { Text } from "../Text";
import { CalendarWeeks } from './CalendarWeeks';
import { SelectableItem } from "../helpers/SelectableItem";
import { DatetimeInputContext } from "../controls/DatetimeInput/DatetimeInputContext";
import { createUIElement } from "../helpers";
import { DEFAULT_TEXTS_MONTH as DEFAULT_TEXTS } from "./helpers";
var WeekRow = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: flex-start;\n"], ["\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: flex-start;\n"])));
var WeekDayTitle = styled(Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 32px;\n    height: 32px;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 8px;\n    font-size: 13px;\n    color: ", ";\n"], ["\n    width: 32px;\n    height: 32px;\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 8px;\n    font-size: 13px;\n    color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorTextMain;
});
export var Month = createUIElement('Month', function (_a, ref) {
    var className = _a.className, year = _a.year, month = _a.month, value = _a.value, _b = _a.hasStaticNumberOfWeek, hasStaticNumberOfWeek = _b === void 0 ? true : _b, onSelect = _a.onSelect, isDayDisabled = _a.isDayDisabled, _c = _a.highlightDates, highlightDates = _c === void 0 ? [] : _c, texts = _a.texts, _d = _a.showCurrentDate, showCurrentDate = _d === void 0 ? true : _d, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "year", "month", "value", "hasStaticNumberOfWeek", "onSelect", "isDayDisabled", "highlightDates", "texts", "showCurrentDate", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var uiTexts = __assign(__assign({}, DEFAULT_TEXTS), texts);
    var weeks = new CalendarWeeks(year, month, 0, hasStaticNumberOfWeek).getDatesGroupedByWeek();
    var now = useContext(DatetimeInputContext).getNowTime();
    var highlightDays = highlightDates.map(function (highlightDate) {
        return highlightDate.toDateString();
    });
    return (React.createElement("div", __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-Month " + className, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(WeekRow, null, Object.values(uiTexts).map(function (i, idx) { return (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(WeekDayTitle, { key: "" + i + idx }, i.substring(0, 2))); })),
        weeks.map(function (dates, idx) { return (
        // eslint-disable-next-line react/no-array-index-key
        React.createElement(WeekRow, { key: idx }, dates.map(function (date) { return (React.createElement(SelectableItem, { key: date.toDateString(), value: date.getDate(), disabled: isDayDisabled ? isDayDisabled(date) : false, onClick: function () {
                if (onSelect) {
                    onSelect(date);
                }
            }, selected: value &&
                date.getFullYear() === value.getFullYear() &&
                date.getMonth() === value.getMonth() &&
                date.getDate() === value.getDate(), isCurrentMonth: date.getFullYear() === year && date.getMonth() === month, isToday: date.getFullYear() === now.getFullYear() &&
                date.getMonth() === now.getMonth() &&
                date.getDate() === now.getDate(), isHighlighted: highlightDays
                ? highlightDays.includes(date.toDateString())
                : false, showCurrentDate: showCurrentDate })); }))); })));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Month.js.map